export const dialogViewportOffset = 'clamp(96px, calc(96px + (100dvh - 1150px) * 0.28), 240px)';
